import React from 'react';
import { CHURCH } from '@/api/client';

function StatCard({ label, value }) {
  return (
    <div className="card-moj p-5">
      <div className="text-xs uppercase tracking-wider text-moj-gold-deep font-bold">{label.replace(/_/g, ' ')}</div>
      <div className="text-3xl font-bold text-moj-purple-deep mt-1">{value}</div>
    </div>
  );
}

export default function OverviewTab({ stats, profile }) {
  if (!stats) return null;
  return (
    <div className="space-y-6">
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {Object.entries(stats).map(([k, v]) => <StatCard key={k} label={k} value={v}/>)}
      </div>
      <div className="card-moj p-6">
        <h3 className="font-serif text-lg text-moj-purple-deep mb-2">Welcome, {profile?.full_name}</h3>
        <p className="text-sm text-moj-charcoal/80">
          You’re managing the public face and the spiritual family of <strong>{CHURCH.name}</strong>. Use the tabs above to review pending members, approve volunteers, publish events, and care for the body. <em>“{CHURCH.motto}” — {CHURCH.scripture}</em>
        </p>
      </div>
    </div>
  );
}
